<div class="logo-container">
  <div
    [ngClass]="{ 'hidden-image': !isVisible }"
    [appCustomTooltip]="imageUrl"
    class="logo-wrapper"
  >
    <img
      id="logo-thumbnail"
      (click)="openLogo()"
      (error)="isVisible = false"
      src="{{ imageUrl }}"
    />
  </div>
</div>
